import PageHandlersService from '@/utils/page-handlers-service';
import LazyLoad from 'vanilla-lazyload';

const pageHandlers = new PageHandlersService();

const init = () => {
    const documentElements = document.querySelectorAll<HTMLElement>('.js-document');
    documentElements.forEach((documentElement) => {
        if (documentElement && documentElement.dataset.index) {
            const popup = document.querySelector(`.js-document-popup[data-index="${documentElement.dataset.index}"]`);
            let isDocumentLoaded = false;

            if (popup) {
                const popupImg = popup.querySelector<HTMLElement>('.js-image-popup-img');
                const closeButton = popup.querySelector('.js-image-popup-close-btn');
                const popupContainer = popup.querySelector('.js-image-popup-container');

                if (!isDocumentLoaded && popupImg) {
                    LazyLoad.load(popupImg, {});
                    isDocumentLoaded = true;
                }

                if (popupImg) {
                    if (popupImg.clientHeight < popupImg.clientWidth) {
                        popup.classList.add('horizontal');
                    } else {
                        popup.classList.add('vertical');
                    }
                }

                pageHandlers.set(documentElement, () => {
                    popup.classList.add('active');
                });

                pageHandlers.set(popupContainer, (event) => {
                    event.stopPropagation();
                });

                pageHandlers.set(closeButton, () => {
                    popup.classList.remove('active');
                });

                pageHandlers.set(popup, () => {
                    popup.classList.remove('active');
                });
            }
        }
    });
};

const destroy = () => pageHandlers.clear();

const _module = { init, destroy };

export default _module;
